import React, { useState, useEffect } from 'react';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

const cardStyle = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '140px',
  width: '210px',
  padding: '14px 18px 14px 22px',
  background: '#ffffff',
  border: '0.5px solid #E5E7EB',
  borderRadius: '10px',
  overflow: 'hidden',
};

const accentStyle = {
  position: 'absolute',
  left: 0, top: 0, bottom: 0,
  width: '3px',
  borderRadius: '10px 0 0 10px',
  background: '#639922',
};

const tagStyle = {
  fontSize: '10px',
  fontWeight: '600',
  letterSpacing: '0.8px',
  textTransform: 'uppercase',
  color: '#9CA3AF',
  marginBottom: '8px',
};

const subStyle = {
  fontSize: '12px',
  color: '#6B7280',
};

const Card9 = () => {
  const [evolution, setEvolution] = useState(null);
  const [loading, setLoading]     = useState(true);
  const [error, setError]         = useState(null);

  useEffect(() => {
    const fetchEvolution = async () => {
      try {
        // Card7 : valeur stock actuel
        const resStock = await fetch(`${API}/valeur_stock`);
        if (!resStock.ok) throw new Error(`Erreur HTTP valeur_stock : ${resStock.status}`);
        const dataStock = await resStock.json();
        const montantDebut = parseFloat(dataStock.valeur_totale ?? 0);

        // Card8 : valeur stock M+12
        const resProjete = await fetch(`${API}/stock_projete`);
        if (!resProjete.ok) throw new Error(`Erreur HTTP stock_projete : ${resProjete.status}`);
        const dataProjete = await resProjete.json();
        let montantFin = 0;
        if (Array.isArray(dataProjete) && dataProjete.length > 0) {
          const derniereLigne = dataProjete[dataProjete.length - 1];
          montantFin = parseFloat(derniereLigne.Montant ?? derniereLigne.montant ?? 0);
        }

        if (montantDebut !== 0 && !isNaN(montantDebut) && !isNaN(montantFin)) {
          const pct = ((montantFin - montantDebut) / montantDebut) * 100;
          setEvolution(pct);
        } else {
          setEvolution(null);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEvolution();
  }, []);

  const isPositive     = evolution !== null && evolution >= 0;
  const formattedValue = evolution !== null
    ? `${isPositive ? '+' : ''}${evolution.toFixed(2)} %`
    : '—';
  const valueColor = isPositive ? '#3B6D11' : '#A32D2D';

  return (
    <div style={cardStyle}>
      <div style={accentStyle} />
      <div style={tagStyle}>Évolution</div>
      <div style={{ fontSize: '22px', fontWeight: '500', color: valueColor, lineHeight: '1', marginBottom: '6px' }}>
        {loading ? 'Chargement…' : error ? 'Erreur' : formattedValue}
      </div>
      <div style={subStyle}>Stock actuel → M+12</div>
    </div>
  );
};

export default Card9;